<template>
  <div>
    <!-- Sticky Top Bar with Breadcrumb -->
    <TopBar
      parentTitle="Prep Terms"
      :currentTitle="prep.term || 'New Prep Term'"
      :backRoute="{ name: 'PrepTermListView' }"
    >
      <b-button outlined type="is-primary" size="is-small" icon-left="check" @click="saveAndClose">Save & Close</b-button>
      <b-button type="is-primary" size="is-small" icon-left="content-save" @click="save">Save</b-button>
    </TopBar>

    <div class="page-content">
      <!-- Page Header -->
      <div class="page-header">
        <div class="page-title-group">
          <h1 class="page-title">{{ prep.term || 'New Prep Term' }}</h1>
          <p class="page-subtitle">Prep Term Editor</p>
        </div>
      </div>

      <!-- Form Card -->
      <FeedsCard title="Prep Term Details">
        <div class="form-group">
          <label class="form-label">Prep Term</label>
          <b-input
            v-model="prep.term"
            placeholder="e.g. chopped"
            @input="saveDebounced" />
        </div>
      </FeedsCard>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import db from "@/firebase/db"
import FeedsCard from "@/components/common/FeedsCard"
import TopBar from "@/components/layout/TopBar"

export default {
  name: 'PrepTermView',
  components: {
    FeedsCard,
    TopBar
  },
  props: [
    'id'
  ],
  data() {
    return {
      prep: {},
    };
  },
  created: function () {
    db.collection('prep_terms')
      .doc(this.id)
      .get()
      .then(snapshot => {
        this.prep = snapshot.data()
      })
  },
  methods: {
    saveDebounced: debounce(function () {
      this.save()
    }, 1000),
    async saveAndClose(){
      this.save()
        .then(() => {
          this.$router.go(-1)
        })
    },
    async save(){
      db.collection('prep_terms')
        .doc(this.id)
        .set(this.prep)
        .then(() => {
          this.$buefy.toast.open({type: 'is-success', message: `Prep term successfully updated!`})
        })
        .catch((error) => {
          this.$buefy.toast.open({type: 'is-danger', message: `Error saving prep term: ${error}`})
        });
    },
  }
}
</script>
